import { gql } from "graphql-tag";

import { FileLink } from "~/app/prismic/prismic-fragments";

export const videoBannerV2 = gql`
  fragment videoBannerV2 on Campaign_sale1BodyVideo_banner_v2 {
    type
    variation {
      variation: __typename
      ... on Campaign_sale1BodyVideo_banner_v2Default {
        primary {
          external_url
        }
      }
      ... on Campaign_sale1BodyVideo_banner_v2Internalvideo {
        primary {
          autoplay
          controls
          internal_url {
            ...fileLink
          }
          internal_tablet_url {
            ...fileLink
          }
          internal_mobile_url {
            ...fileLink
          }
        }
      }
    }
  }
  ${FileLink}
`;
